module.exports = __webpack_public_path__ + "assets/img/number_times_item3.32f056ba.png";